import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../services/api.service';
import { CookieService } from 'ngx-cookie-service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  invalidLogin: boolean = false;
  captchaCode: string = '';
  captchaError: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private apiService: ApiService    ,
    private cookieService: CookieService
  ) {}

  refreshCaptcha() {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    let code = '';
    for (let i = 0; i < 6; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    this.captchaCode = code;
    if (this.loginForm && this.loginForm.controls.captcha) {
      this.loginForm.controls.captcha.setValue('');
    }
    this.captchaError = false;
  }

  onSubmit() {
    if (this.loginForm.invalid) {
      return;
    }
    if (this.loginForm.controls.captcha.value.trim().toUpperCase() !== this.captchaCode) {
      this.captchaError = true;
      this.refreshCaptcha();
      return;
    }
    const loginPayload = {
      employeeId: this.loginForm.controls.username.value,
      password: this.loginForm.controls.password.value,
    };
    /* if(this.loginForm.controls.username.value == "admin" && this.loginForm.controls.password.value =="123456"){
    this.router.navigate(['dashboard']);
    window.localStorage.setItem('token', "loggedIn");
   }*/

    this.apiService.login(loginPayload).subscribe((data) => {
       if (data.isSuccess === true) {
        let expire = new Date();
        var time = Date.now() + ((3600 * 1000) * 0.2);
        expire.setTime(time);
        this.cookieService.set('LOGIN_TOKEN',"loggedIn",expire);
        window.localStorage.setItem('loggedInUser', this.loginForm.controls.username.value);
        this.router.navigate(['command-center']);
      } else {
        this.invalidLogin = true;
        alert('Login failed');
      }
    });
  }

  ngOnInit() {
    // Always show the login form (no auto-redirect). Clear any stale session cookie.
    this.cookieService.delete('LOGIN_TOKEN');
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.compose([Validators.required])],
      password: ['', Validators.required],
      captcha: ['', Validators.required],
    });
    this.refreshCaptcha();
  }
}
